import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

const OnboardingWizardShell = ({
  navItems = [],
  showNavPlaceholder = false,
  children,
}) => {
  const hasNav = navItems.length > 0 || showNavPlaceholder;

  return (
    <div className="rounded-radius border border-border bg-card p-4 overflow-x-hidden sm:p-6 lg:flex-1 lg:min-h-0 lg:overflow-auto lg:app-scroll">
      <div
        className={cn(
          "grid gap-6 lg:gap-8",
          hasNav ? "lg:grid-cols-[280px_1fr] xl:grid-cols-[320px_1fr]" : "",
        )}
      >
        {hasNav ? (
          <aside className="h-fit self-start lg:sticky lg:top-0 lg:border-r lg:border-border lg:pr-4">
            {navItems.length > 0 ? (
              <div className="grid grid-cols-1 gap-2 pb-1 min-[420px]:grid-cols-2 lg:flex lg:flex-col lg:overflow-visible lg:pb-0">
                {navItems.map((item) => {
                  const Icon = item.icon;
                  return (
                    <button
                      key={item.id}
                      type="button"
                      onClick={item.onClick}
                      className={cn(
                        "flex w-full min-w-0 items-center gap-3 rounded-radius px-3 py-2 text-left text-sm transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
                        item.isActive
                          ? "bg-primary/10 text-primary"
                          : item.isDone
                            ? "bg-primary/5 text-foreground"
                            : "bg-muted/30 text-muted-foreground hover:bg-muted/50",
                      )}
                    >
                      <span
                        className={cn(
                          "flex h-9 w-9 flex-none items-center justify-center rounded-full border",
                          item.isDone
                            ? "border-primary/40 bg-primary/10 text-primary"
                            : item.isActive
                              ? "border-primary/40 bg-background text-primary"
                              : "border-border bg-background/80 text-muted-foreground",
                        )}
                      >
                        {item.isDone ? (
                          <Check className="h-4 w-4" />
                        ) : Icon ? (
                          <Icon className="h-4 w-4" />
                        ) : null}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block text-sm font-semibold text-foreground">
                          {item.title}
                        </span>
                        {item.description ? (
                          <span className="block text-xs text-muted-foreground">
                            {item.description}
                          </span>
                        ) : null}
                      </span>
                    </button>
                  );
                })}
              </div>
            ) : (
              <div className="space-y-3 rounded-radius border border-dashed border-border/70 bg-muted/20 px-4 py-5 text-xs text-muted-foreground">
                <div className="h-2 w-3/5 rounded bg-muted/40" />
                <div className="h-2 w-4/5 rounded bg-muted/30" />
                <div className="h-2 w-2/5 rounded bg-muted/30" />
                <p className="pt-2">Steps will appear here.</p>
              </div>
            )}
          </aside>
        ) : null}
        <section className="min-w-0 space-y-4">{children}</section>
      </div>
    </div>
  );
};

export default OnboardingWizardShell;
